import { call, put, takeLatest } from "@redux-saga/core/effects";
import { VendorDetailApi } from "./VendorDetailApi";
import { VendorDetailConstant } from "./VendorDetailConstant";
import { VendorDetailParser } from "./VendorDetailParser";

function* getVendorDetailList({ payload }) {
  try {
    yield put({ type: VendorDetailConstant.VENDOR_DETAIL_REQUEST });

    const res = yield call(VendorDetailApi.getVendorDetail, payload);

    yield put({
      type: VendorDetailConstant.VENDOR_DETAIL_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log(e);
    yield put({
      type: VendorDetailConstant.VENDOR_DETAIL_RESPONSE,
      payload: [],
    });
  }
}

function* chargingEnableDisable({ payload }) {
  const { id, status } = payload;

  try {
    yield put({ type: VendorDetailConstant.CHARGING_ENABLE_DISABLE_REQUEST });
    const res = yield call(VendorDetailApi.chargingEnableDisable, {
      id,
      status,
    });
    const payload = res;
    yield put({
      type: VendorDetailConstant.CHARGING_ENABLE_DISABLE_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    yield put({
      type: VendorDetailConstant.CHARGING_ENABLE_DISABLE_RESPONSE,
      payload: [],
    });
  }
}

function* chargingPointEnableDisable({ payload }) {
  const { id, status } = payload;

  try {
    yield put({
      type: VendorDetailConstant.CHARGING_POINT_ENABLE_DISABLE_REQUEST,
    });
    const res = yield call(VendorDetailApi.chargingPointEnableDisable, {
      id,
      status,
    });
    const payload = res;
    yield put({
      type: VendorDetailConstant.CHARGING_POINT_ENABLE_DISABLE_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    yield put({
      type: VendorDetailConstant.CHARGING_POINT_ENABLE_DISABLE_RESPONSE,
      payload: [],
    });
  }
}

function* chargingPointDelete({ payload }) {
  const { id } = payload;

  try {
    yield put({ type: VendorDetailConstant.CHARGING_POINT_DELETE_REQUEST });
    const res = yield call(VendorDetailApi.chargingPointDelete, { id });
    const payload = res;
    yield put({
      type: VendorDetailConstant.CHARGING_POINT_DELETE_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    yield put({
      type: VendorDetailConstant.CHARGING_POINT_DELETE_RESPONSE,
      payload: [],
    });
  }
}

function* getRequestViewDetailsVendorSaga(id) {
  try {
    yield put({
      type: VendorDetailConstant.GET_REQUEST_VIEW_VENDOR_DETAILS_REQUEST,
    });

    const res = yield call(VendorDetailApi.getRequestViewDetailsVendorApi, id);

    const payload = VendorDetailParser.getRequestViewDetailsVendorParser(res);

    yield put({
      type: VendorDetailConstant.GET_REQUEST_VIEW_VENDOR_DETAILS_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: VendorDetailConstant.GET_REQUEST_VIEW_VENDOR_DETAILS_RESPONSE,
      payload: [],
    });
  }
}

export function* registerVendordetailSaga() {
  yield takeLatest(
    VendorDetailConstant.VENDOR_DETAIL_SAGA,
    getVendorDetailList
  );
  yield takeLatest(
    VendorDetailConstant.CHARGING_ENABLE_DISABLE_SAGA,
    chargingEnableDisable
  );
  yield takeLatest(
    VendorDetailConstant.CHARGING_POINT_DELETE_SAGA,
    chargingPointDelete
  );
  yield takeLatest(
    VendorDetailConstant.CHARGING_POINT_ENABLE_DISABLE_SAGA,
    chargingPointEnableDisable
  );
  yield takeLatest(
    VendorDetailConstant.GET_REQUEST_VIEW_VENDOR_DETAILS_SAGA,
    getRequestViewDetailsVendorSaga
  );
}
